export const home = {
myReports: {
title: "Ihre Meldungen",
},
meta: {
untitledJob: "Unbenannter Auftrag",
noAssetLinked: "Keine Anlage verknüpft",
unassigned: "Nicht zugewiesen",
emDash: "—",
},
aggregation: {
scheduledInspectionFallback: "Geplante Prüfung",
jobOverdueSubtitle: "{{asset}} · Fällig {{date}}",
jobOverdueNoDate: "{{asset}} · Überfällig",
jobOverdueUnassigned: "Überfälliger Auftrag",
inspectionOverdueSubtitle: "{{asset}} · War fällig am {{date}}",
requestOverdueSubtitle: "{{asset}} · War fällig am {{date}}",
jobDueTodaySubtitle: "{{asset}} · Heute fällig",
inspectionDueTodaySubtitle: "{{asset}} · Heute fällig",
inspectionScheduledSubtitle: "{{asset}} · Geplant für {{date}}",
jobInProgressSubtitle: "{{asset}} · In Bearbeitung",
followOnApprovalSubtitle: "{{asset}} · Folgegenehmigung",
completionReviewSubtitle: "{{asset}} · Abschlussprüfung",
scheduledBadge: "Geplant",
inProgressBadge: "In Bearbeitung",
approvalBadge: "Genehmigung",
requestSubtitle: "{{asset}} · Nachverfolgung",
followUpQueuePending: "Neu",
followUpQueueAwaitingCustomer: "Wartet auf Kunde",
followUpQueueApproved: "Genehmigt",
followUpQueueScheduled: "Geplant",
followUpQueueConverted: "Verknüpfte Arbeit",
followUpQueueRejected: "Abgelehnt",
certificateActionsTitle: "Fällige Zertifikate",
certificateActionsEmpty: "Keine fälligen Zertifikate",
certificatePendingValidation: "Validierung ausstehend",
certificateRejected: "Abgelehnt",
certificateExpired: "Abgelaufen",
certificateExpiringSoon: "Läuft bald ab",
},
greeting: {
morning: "Guten Morgen",
afternoon: "Guten Tag",
evening: "Guten Abend",
withName: "{{greet}}, {{name}}",
},
screen: {
title: "Start",
loadingCommandCenter: "Startseite wird geladen…",
},
summaryStrip: {
assets: "Anlagen",
openJobs: "Offene Aufträge",
dueToday: "Heute fällig",
requests: "Anfragen",
},
commandQuickActions: {
scanQr: "QR scannen",
},
commandEmpty: {
dueToday: "Heute ist nichts fällig.",
needsAttention: "Im Moment ist keine Aufmerksamkeit nötig.",
requests: "Noch keine Anfragen. Geteilte Anlagenanfragen erscheinen hier.",
recentActivity: "Keine letzte Aktivität.",
},
commandSectionTitles: {
overdue: "Überfällig",
dueToday: "Heute fällig",
requests: "Anfragen",
recentActivity: "Letzte Aktivität",
},
commandCenter: {
statusBar: {
actionRequired: "Aktion erforderlich",
needsAttention: "Erfordert Aufmerksamkeit",
allSystemsNormal: "Alles im normalen Bereich",
synced: "Synchronisiert {{label}}",
},
aiBriefing: {
label: "Operatives Briefing",
readMore: "Briefing lesen →",
},
attentionQueue: {
title: "Aufmerksamkeitsliste",
empty: "Posteingang leer. Momentan ist nichts von Ihnen gefordert.",
showMore: "{{count}} weitere →",
snooze: "Zurückstellen",
kind: {
request: "Anfragen",
inspection: "Inspektionen",
job: "Aufträge",
document: "Dokumente",
activity: "Aktivität",
},
},
counters: {
dueInspections: "Fällige Prüfungen",
openRequests: "Offene Anfragen",
openJobs: "Offene Aufträge",
workQueue: "Arbeitswarteschlange",
},
recentActivity: {
title: "Letzte Aktivität",
defaultEmpty: "Heute noch keine Aktivität.",
events_one: "{{count}} Ereignis",
events_other: "{{count}} Ereignisse",
},
},
empty: {
firstAssetTitle: "Erstellen Sie Ihre erste Anlage",
firstAssetSubtitle: "Fügen Sie eine Anlage hinzu, um Inspektionen zu starten und Arbeit zu steuern.",
noAssetsInScopeTitle: "Keine Anlagen in {{scope}}",
noAssetsInScopeSubtitle: "Ändern Sie den Bereichsfilter oben oder fügen Sie diesem Team Anlagen hinzu.",
noAssetsInScopeSubtitleWeb: "Ändern Sie den Bereichsfilter oder leeren Sie die Suche — passende Anlagen erscheinen hier.",
noAssetsInScopeShortWeb: "Bereich ändern oder Anlagen zu diesem Team hinzufügen.",
addAsset: "Anlage hinzufügen",
},
planNudge: {
asset_cap_limited: "Noch eine Anlage auf Ihrem Plan ({{limit}} enthalten). {{plan}} enthält {{nextLimit}}.",
asset_cap: "Noch eine Anlage frei in Ihrem Tarif ({{limit}} enthalten). {{plan}} hat kein Limit.",
same_contact: "Sie haben {{name}} diesen Monat {{count}} Aufträge geschickt. Mit {{plan}} sieht und aktualisiert die Person sie selbst.",
addresses: "Ihre Anlagen stehen an {{count}} Adressen. Standorte in {{plan}} ordnen die Arbeit nach Ort.",
inspections: "{{count}} Inspektionen in einer Woche sind viel für eine Person. Teams in {{plan}} verteilen die Last.",
seePlans: "{{plan}} ansehen",
dismiss: "Jetzt nicht",
},
teamSetup: {
title: "Team einrichten",
dismiss: "Team-Einrichtung ausblenden",
steps: {
invite: "Teammitglied einladen",
site: "Standort anlegen",
requests: "Anderen das Melden von Arbeit erlauben (Anlage teilen)",
},
},
firstRun: {
progress: "{{completed}} von {{total}} fertig",
gettingStartedDefault: "Erste Schritte",
dismissDefault: "Erste Schritte verwerfen",
trySampleDefault: "Probieren Sie ein Beispiel aus",
removeSampleDefault: "Beispiel entfernen",
title: "Erste Schritte",
subtitle: "Tippen Sie auf einen Schritt. Jeder zeigt Ihnen genau, wo Sie tippen.",
trySample: "Beispiel testen",
removeSample: "Beispiel entfernen",
createAsset: "Anlage erstellen",
startInspection: "Inspektion starten",
dismiss: "Später",
whatIsThis: "Was ist das?",
whatIsThisBody: "AssetWRX hält Ihre Anlagen, Inspektionen und Aufträge an einem Ort, damit Sie immer wissen, was als Nächstes zu tun ist.",
busy: "Wird eingerichtet…",
error: "Beispiel konnte nicht eingerichtet werden. Sie können weiterhin manuell eine Anlage anlegen.",
suggested: "Empfohlen",
steps: {
  document: "Ein Zertifikat hinzufügen",
asset: "Erste Anlage hinzufügen",
request: "Eine Anlage mit jemandem teilen",
inspection: "Eine Inspektion planen",
job: "Einen Auftrag anlegen",
contacts: "Eine Kollegin oder einen Kollegen einladen",
contactsNoTeams: "Einen Kontakt hinzufügen",
},
coachmark: {
title: "Hier starten",
body: "Tippen Sie auf einen Schritt, um zu beginnen. Die Reihenfolge ist egal.",
dismiss: "Verstanden",
},
},
web: {
commandOverline: "Suchen und erstellen",
commandHint: "Arbeitsbereich durchsuchen, Bereich wählen oder Anlagen, Aufträge und Inspektionen hinzufügen.",
searchPlaceholder: "Anlagen, Aufträge, Inspektionen, Berichte suchen…",
overviewTitle: "Überblick",
overviewHint: "Shortcuts und Live-Zahlen für Ihren Bereich. Tippen Sie auf eine KPI-Kachel für die vollständige Liste.",
overviewSnapshotLabel: "Momentaufnahme",
overviewSnapshotHintWeb: "Anlagen · Inspektionen · Aufträge — Kachel antippen, um die Liste zu öffnen",
suggestedActionsTitle: "Vorgeschlagene Aktionen",
suggestedActionsHint: "Regelbasierte Prioritäten in diesem Bereich. Karte öffnen, um zur passenden Liste oder zum Auftrag zu springen.",
workQueueTitle: "Arbeitswarteschlange",
workQueueHint: "Priorisierte Aufträge und Inspektionen für diesen Bereich. Zeile wählen für Details.",
activeWorkQueueTitle: "Aktive Arbeitswarteschlange",
workQueueSectionMeta: "Aufträge, Inspektionen und Pläne — filtern oder Zeile für Details öffnen.",
queueEmptyNoItems: "Keine bearbeitbaren Aufträge oder Inspektionen in diesem Bereich.",
queueEmptyNoFilter: "Keine Einträge entsprechen diesem Filter.",
automationHint: "Umwandlungen, regelbasierte Auftragsvorschläge aus abgeschlossenen Inspektionen und Teameinladungen.",
detailJobTitle: "Auftragsdetails",
detailOverviewTitle: "Überblick",
detailEmpty: "Noch keine Arbeitselemente in diesem Bereich. Nutzen Sie „Schnell erstellen“ in der Kopfzeile.",
detailCommandSummary: "Zusammenfassung",
detailIdleLead: "Wählen Sie eine Zeile in der Warteschlange für Details, Hauptaktionen und letzte Aktivität.",
detailStatOpenJobs: "Offene Aufträge",
detailStatOverdue: "Überfällig",
detailStatUnassigned: "Nicht zugewiesen",
detailNextUp: "Als Nächstes in der Warteschlange",
viewAssetDetailsA11y: "Alle Anlagendetails anzeigen",
scheduleWorkA11y: "Arbeit planen",
moreActions: "Weitere Aktionen",
moreActionsA11y: "Weitere Aktionen",
copilotSectionTitle: "Operations-Assistent",
copilotEmptyTitle: "Keine priorisierten Signale",
copilotEmptyBody: "Für diesen Bereich ist noch nichts Dringendes sichtbar. Filter anpassen, Arbeit erfassen oder Analysen und Arbeit auf Trends prüfen.",
copilotDockHint: "Regelbasierte Prioritäten für Ihren Bereich. Jede Karte verlinkt zur passenden Liste oder zum Auftrag.",
},
snapshot: {
inspectionsSublabelDrafts: "Entwürfe & pausiert",
inspectionsSublabelScheduled_one: "Entwürfe & pausiert · {{count}} geplant",
inspectionsSublabelScheduled_other: "Entwürfe & pausiert · {{count}} geplant",
jobsSublabelNotClosed: "Nicht abgeschlossen",
jobsSublabelOverdue_one: "Nicht abgeschlossen · {{count}} überfällig",
jobsSublabelOverdue_other: "Nicht abgeschlossen · {{count}} überfällig",
inThisScope: "In diesem Bereich",
findingsSublabel: "Abgeschlossene Berichte mit nicht bestandenen Punkten",
unassignedSublabel: "Offene Aufträge ohne Verantwortliche",
},
queueFilter: {
all: "Alle Arbeit",
overdue: "Überfällig",
inProgress: "In Bearbeitung",
dueSoon: "Bald fällig",
},
queue: {
labels: {
asset: "Anlage",
due: "Fällig",
status: "Status",
assignee: "Zugewiesen an",
scheduled: "Geplant",
nextStep: "Nächster Schritt",
started: "Gestartet",
priority: "Priorität",
created: "Erstellt",
location: "Standort",
dueDate: "Fälligkeitsdatum",
},
status: {
overdue: "Überfällig",
due: "Fällig",
paused: "Pausiert",
inProgress: "In Bearbeitung",
awaitingSchedule: "Wartet auf Termin",
unassigned: "Nicht zugewiesen",
},
subtitle: {
overdue: "{{asset}} • Überfällig",
activeWork: "{{asset}} • Aktive Arbeit",
dueThisWeek: "{{asset}} • Fällig diese Woche",
scheduledInspection: "{{asset}} • Geplante Inspektion",
needsSchedule: "{{asset}} • Termin nötig",
unassigned: "{{asset}} • Nicht zugewiesen",
resumeChecklist: "{{asset}} • Checkliste fortsetzen",
},
title: {
inspectionOverdue: "Inspektion überfällig",
inspectionDue: "Inspektion fällig",
inspectionInProgress: "Inspektion läuft",
},
typeJob: "Auftrag",
typeInspection: "Inspektion",
primaryOpenJob: "Auftrag öffnen",
primaryResumeInspection: "Inspektion fortsetzen",
primaryStartInspection: "Inspektion starten",
openWork: "Arbeit öffnen",
nextStepSetSchedule: "Datum und Uhrzeit festlegen",
nextStepAssign: "Team oder Auftragnehmer zuweisen",
},
sections: {
quickActions: "Schnellaktionen",
quickActionsCardTitle: "Schnellzugriffe",
quickActionsHintSetup: "Scannen und Arbeit anlegen.",
quickActionsHintFull: "Scannen, Arbeit anlegen und zu dringenden Punkten springen.",
snapshot: "Momentaufnahme",
snapshotHint: "Anlagen · Inspektionen · Aufträge — tippen zum Öffnen",
myWork: "Meine Arbeit",
myWorkHint: "Ihre Arbeit fortsetzen, zuweisen oder abschließen.",
needsAttention: "Erfordert Aufmerksamkeit",
needsAttentionHint: "Nach Typ gruppiert — gleiche Einträge, übersichtlicher.",
workflowSuggestions: "Workflow-Vorschläge",
workflowHint: "Ergebnisse des Inspektions-Workflows bereit für den nächsten Schritt.",
viewAll: "Alle anzeigen",
attentionQueue: "Aufmerksamkeit",
attentionQueueCollapsedHint: "Tippen, um die vollständige Prioritätenübersicht zu öffnen",
attentionQueueShowLess: "Weniger anzeigen",
attentionEmpty: "Keine dringende Arbeit im Bereich.",
moreToolsTitle: "Weitere Tools",
moreToolsBody: "Analysen, vollständiger Aktivitätsverlauf und die Werkbank.",
contractorInvitesBanner_one: "Sie haben eine Einladung, ein Angebot abzugeben oder einen Auftrag zu übernehmen — tippen, um zu antworten",
contractorInvitesBanner_other: "Sie haben {{count}} Einladungen, ein Angebot abzugeben oder Aufträge zu übernehmen — tippen, um zu antworten",
workspaceDeeperTitle: "Weitere Signale",
workspaceDeeperSummary: "Pläne, aktive Arbeit und Aktivität.",
commandShortcutsTitle: "Erstellen oder öffnen",
commandShortcutsSummary: "Arbeit hinzufügen oder nächste Warteschlange öffnen.",
jumpToTitle: "Öffnen",
jumpToSummary: "Register und Berichte.",
},
welcome: {
subtitleDefault: "Arbeit heute",
subtitleRecipient: "Geteilte Berichte und Aufträge warten auf Ihre Antwort",
},
kpiStrip: {
pendingReviews: "Überprüfungen",
pendingReviewsSub: "Warten auf Ihre Antwort",
complianceSub: "Dokumente & überfällige Prüfungen",
},
attentionGroups: {
approvals: "Freigaben & Prüfungen",
people: "Personen & Rückmeldungen",
time: "Zeit & Risiko",
},
tasks: {
jobInvitations: {
title: "Auftragseinladungen",
sub: "Annehmen oder ablehnen",
},
yourTurn: {
title: "Sie sind dran",
sub: "Auftrag annehmen oder ablehnen",
},
reworkRequested: {
title: "Nacharbeit angefordert",
sub: "Auftrag neu zuweisen",
},
workInProgress: {
title: "Arbeit läuft",
sub: "Abschließen oder Update posten",
},
scheduleProposed: {
title: "Termin vorgeschlagen",
sub: "Datum und Uhrzeit festlegen",
},
approvedRepairs: {
title: "Genehmigte Reparaturen",
sub: "In Aufträge umwandeln",
},
unassignedWork: {
title: "Nicht zugewiesene Arbeit",
sub: "Team oder Auftragnehmer zuweisen",
},
draftInspection: {
title: "Inspektionsentwurf",
sub: "Fortsetzen",
},
inspectionDue: {
title: "Inspektion fällig",
sub: "Überfällig oder 60+ Tage",
},
criticalIssues: {
title: "Kritische Punkte",
sub: "Gesundheitsstatus schlecht",
},
followOnProposed: {
title: "Folgeauftrag vorgeschlagen",
sub: "Vor Zuweisung genehmigen oder ablehnen",
},
completionSubmitted: {
title: "Abschluss eingereicht",
sub: "Genehmigen oder Nacharbeit anfordern",
},
reportAwaitingReview: {
title: "Bericht wartet auf Prüfung",
sub: "Reparaturen genehmigen oder ablehnen",
},
awaitingRecipient: {
title: "Warten auf Empfänger",
sub: "Prüfen",
},
awaitingRecipientResponse: {
title: "Warten auf Empfängerantwort",
sub: "Ausstehende Prüfungen verfolgen und nachhaken",
},
overdueJobs: {
title: "Überfällige Aufträge",
sub: "Stockende Arbeit klären",
},
},
pinned: {
scanQr: "QR scannen",
inspect: "Inspizieren",
createJob: "Auftrag erstellen",
},
contextual: {
reviewReport: "Bericht prüfen",
respondToAssignment: "Auf Zuweisung reagieren",
approveFollowOn: "Folgeauftrag genehmigen",
approveCompletion: "Abschluss genehmigen",
continueJob: "Auftrag fortsetzen",
resumeInspection: "Inspektion fortsetzen",
addAsset: "Anlage hinzufügen",
},
webQuickCreate: {
createInspection: "Inspektion erstellen",
createTemplate: "Checkliste erstellen",
createJob: "Auftrag erstellen",
scheduleWork: "Arbeit planen",
shortAsset: "Anlage",
shortRequest: "Anfrage",
shortInspection: "Prüfen",
shortJob: "Auftrag",
},
kpi: {
assets: "Anlagen",
inspections: "Inspektionen",
jobs: "Aufträge",
unassigned: "Nicht zugewiesen",
findings: "Befunde",
},
automation: {
approvedRepairsTitle: "Genehmigte Reparaturen",
suggestedJobsTitle: "Folgeaufträge aus Inspektion",
teamInvitesTitle: "Teameinladungen",
},
urgency: {
critical: "Kritisch",
medium: "Mittel",
low: "Niedrig",
},
priorityDot: {
a11y: "Priorität {{level}}",
level: {
p1: "kritisch",
p2: "mittel",
p3: "niedrig",
none: "keine",
},
},
workLanes: {
kindLabel: {
request: "Anfragen",
inspection: "Inspektionen",
job: "Aufträge",
},
kindLabelLower: {
request: "Anfragen",
inspection: "Inspektionen",
job: "Arbeitsaufträge",
},
empty: "Hier braucht Sie nichts.",
viewAll: "Alle {{count}} {{kind}} anzeigen →",
},
assetGroups: {
overdueBadge_one: "{{count}} überfällig",
overdueBadge_other: "{{count}} überfällig",
needsYouBadge: "{{count}} für Sie",
openAssetMore: "Anlage öffnen · {{count}} mehr →",
openAsset: "Anlage öffnen →",
moreAssets_one: "{{count}} weitere Anlage mit offener Arbeit",
moreAssets_other: "{{count}} weitere Anlagen mit offener Arbeit",
},
sharedAssets: {
invitesA11y_one: "{{count}} Anlageneinladung – annehmen oder ablehnen",
invitesA11y_other: "{{count}} Anlageneinladungen – annehmen oder ablehnen",
invitesTitle_one: "Eine Anlage wurde mit Ihnen geteilt",
invitesTitle_other: "{{count}} Anlagen wurden mit Ihnen geteilt",
tapToAcceptOrDecline: "Tippen Sie zum Akzeptieren oder Ablehnen",
activeA11y: "{{name}} – mit Ihnen geteilt. Öffnen Sie es, um ein Problem zu melden oder seine Arbeit zu sehen.",
activeSub: "Mit Ihnen geteilt · Melden Sie ein Problem oder sehen Sie sich seine Arbeit an",
},
sectionCard: {
otherGroup: "Sonstiges",
emptyDefault: "Hier ist noch nichts",
},
commandCentre: {
  showMeHow: "Zeig mir, wie",
calendar: "Kalender",
stateLabel: {
actionNeeded: "Aktion erforderlich",
watch: "Im Blick behalten",
active: "Aktiv",
clear: "In Ordnung",
},
eyebrow: {
needsYou: "Braucht Sie",
now: "Jetzt",
decision: "Entscheidung",
},
onYourPlate: "Ihre Aufgaben",
watchlist: "Im Blick behalten",
upNext: "Als Nächstes",
portfolioMovement: "Was sich geändert hat",
workspaceSummary: "Arbeitsbereich im Überblick",
toMonitor: "{{count}} zu prüfen",
seeAll: "Alle anzeigen",
seeAllA11y: "Alle {{count}} anzeigen",
assetRowA11y: "{{name}}. {{state}}. {{reason}}",
signalLabels: {
needsYou: "Braucht Sie",
atRisk: "Gefährdet",
inMotion: "Aktiv",
dueSoon: "Bald fällig",
},
viewDetails: "Details anzeigen",
moreOnAsset_one: "{{count}} weiterer Eintrag bei {{name}} erfordert dieselbe Entscheidung",
moreOnAsset_other: "{{count}} weitere Einträge bei {{name}} erfordern dieselbe Entscheidung",
moreOnAssetA11y_one: "{{count}} weiterer Eintrag bei {{name}} erfordert dieselbe Entscheidung. Unter „Arbeit“ öffnen",
moreOnAssetA11y_other: "{{count}} weitere Einträge bei {{name}} erfordern dieselbe Entscheidung. Unter „Arbeit“ öffnen",
signalRowA11y: "{{action}}: {{name}}. {{reason}}",
},
decisionModel: {
action: {
confirm: "Bestätigen",
reply: "Antworten",
review: "Prüfen",
resolve: "Klären",
createWork: "Arbeit erstellen",
resubmit: "Erneut einreichen",
inviteMore: "Mehr einladen",
respond: "Antworten",
open: "Öffnen",
quote: "Angebot abgeben",
triage: "Entscheiden",
resume: "Fortsetzen",
start: "Starten",
continueJob: "Weiter",
inspect: "Prüfen",
},
reason: {
overdue: "Überfällige Arbeiten erfordern Aufmerksamkeit",
blocked: "Arbeit ist blockiert und erfordert eine Entscheidung",
doneConfirmWithName: "{{name}} hat dies als erledigt markiert – bestätigen Sie die Korrektur",
doneConfirm: "Die Arbeit ist erledigt – bestätigen Sie die Korrektur",
visitConfirmWithName: "{{name}} hat einen Besuch geplant – bestätigen Sie, dass jemand dort sein kann, oder fragen Sie nach einer anderen Zeit",
visitConfirm: "Ein Besuch ist geplant – bestätigen Sie, dass jemand dort sein kann, oder fragen Sie nach einer anderen Zeit",
needMoreInfo: "Das Team benötigt weitere Informationen von Ihnen",
waitingYourReview: "Wartet auf Ihre Prüfung",
waitingYourReviewWithName: "{{name}} wartet auf Ihre Bewertung",
reviewWaiting: "Eine Überprüfung oder Genehmigung wartet",
approvedNoWorkYet: "Genehmigt – die Arbeit wurde noch nicht angelegt",
reworkSentBackWithName: "Zur Überarbeitung an {{name}} zurückgeschickt – wartet darauf, dass sie es erneut abschließen",
reworkSentBack: "Zur Überarbeitung zurückgeschickt – wartet darauf, dass es erneut abgeschlossen wird",
reworkOwnerRedo: "Zur Überarbeitung zurückgeschickt – Arbeit wiederholen und erneut abschließen",
quotesDeclined: "Alle Eingeladenen lehnten es ab, ein Angebot abzugeben – laden Sie weitere Auftragnehmer ein",
waitingRequesterConfirm: "Wartet darauf, dass die anfragende Person die Behebung bestätigt",
acceptOrDeclineYou: "Ihnen zugewiesen – akzeptieren oder ablehnen, bevor die Arbeit beginnt",
waitingAcceptWithName: "Warten auf die Annahme oder Ablehnung durch {{name}}",
waitingAccept: "Warten auf die Annahme oder Ablehnung durch den Beauftragten",
waitingTriageWithName: "{{name}} wartet auf eine Entscheidung",
waitingTriage: "Ein Anforderer wartet auf eine Entscheidung",
workspaceUnavailable: "Ihr Arbeitsbereich konnte nicht geladen werden. Tippen Sie, um es erneut zu versuchen.",
dueToday: "Heute fällig",
invitedToQuote: "Eingeladen, ein Angebot abzugeben – antworten Sie mit einem Preis oder lehnen Sie ab",
pausedWithReason: "Angehalten – {{reason}}. Machen Sie weiter, wenn Sie können",
pausedResume: "Angehalten – fortfahren, wenn Sie können",
onThisJob: "Sie sind für diesen Auftrag eingeteilt – schließen Sie ihn ab, wenn die Arbeit erledigt ist",
assignedStartOnSite: "Ihnen zugewiesen – beginnen Sie, wenn Sie vor Ort sind",
scheduledApproaching: "Die geplanten Arbeiten stehen vor der Tür",
pausedWithReasonOnly: "Angehalten – {{reason}}",
paused: "Pausiert",
inProgress: "Die Arbeiten sind im Gange",
fallback: "Operative Aufmerksamkeit ist erforderlich",
},
assetReason: {
actionRequired: "Aktion ist erforderlich",
criticalRisk: "Kritisches Anlagenrisiko",
elevatedRisk: "Erhöhtes Anlagenrisiko",
operationalConcern: "Betriebsproblem",
activeOrScheduled: "Arbeit ist aktiv oder geplant",
noException: "Nichts braucht Aufmerksamkeit",
},
assetWatchSignal: {
criticalMonitor: "Kritisches Anlagenrisiko erfordert Überwachung",
elevatedMonitor: "Erhöhtes Anlagenrisiko erfordert Überwachung",
conditionNeedsAction: "Zustand erfordert Maßnahmen",
},
brief: {
itemsNeed_one: "{{count}} Eintrag erfordert Aufmerksamkeit.",
itemsNeed_other: "{{count}} Einträge erfordern Aufmerksamkeit.",
conditionsWatchClause_one: " {{count}} weiteren Punkt im Blick behalten.",
conditionsWatchClause_other: " {{count}} weitere Punkte im Blick behalten.",
nothingNeedsYou: "Im Moment braucht Sie nichts.",
watchlist_one: "Im Moment braucht Sie nichts. {{count}} Punkt im Blick behalten.{{motion}}",
watchlist_other: "Im Moment braucht Sie nichts. {{count}} Punkte im Blick behalten.{{motion}}",
inMotionOnly_one: "Im Moment braucht Sie nichts. {{count}} Eintrag ist geplant oder in Bearbeitung.",
inMotionOnly_other: "Im Moment braucht Sie nichts. {{count}} Einträge sind geplant oder in Bearbeitung.",
invitationsOnly_one: "{{count}} Einladung, ein Angebot abzugeben oder einen Auftrag zu übernehmen, wartet auf Ihre Antwort.",
invitationsOnly_other: "{{count}} Einladungen, ein Angebot abzugeben oder Aufträge zu übernehmen, warten auf Ihre Antwort.",
inMotionClause_one: " {{count}} Eintrag ist geplant oder in Bearbeitung.",
inMotionClause_other: " {{count}} Einträge sind geplant oder in Bearbeitung.",
},
},
copilot: {
overdue: {
title: "Überfällige Arbeit",
body_one: "{{count}} offener Auftrag mit Fälligkeit in der Vergangenheit. Priorisieren Sie Terminierung oder Abschluss.",
body_other: "{{count}} offene Aufträge mit Fälligkeit in der Vergangenheit. Priorisieren Sie Terminierung oder Abschluss.",
action: "Aufträge öffnen",
},
failedFindings: {
title: "Inspektionsbefunde",
body_one: "{{count}} abgeschlossene Inspektion in diesem Bereich enthält nicht bestandene Punkte. Wandeln Sie kritische Befunde bei Bedarf in Aufträge um.",
body_other: "{{count}} abgeschlossene Inspektionen in diesem Bereich enthalten nicht bestandene Punkte. Wandeln Sie kritische Befunde bei Bedarf in Aufträge um.",
action: "Inspektionen",
},
throughput: {
title: "Abschlusstempo",
bodyUp: "Verifizierte Auftragsabschlüsse haben sich in der zweiten Hälfte der letzten {{days}} Tage beschleunigt.",
bodyDown: "Verifizierte Auftragsabschlüsse haben in der zweiten Hälfte der letzten {{days}} Tage nachgelassen. Blockaden in der Warteschlange prüfen.",
action: "Arbeitswarteschlange",
},
unassigned: {
title: "Zuweisungsabdeckung",
body_one: "{{count}} offener Auftrag ohne Verantwortliche. Zuweisungen erhöhen die Nachvollziehbarkeit.",
body_other: "{{count}} offene Aufträge ohne Verantwortliche. Zuweisungen erhöhen die Nachvollziehbarkeit.",
action: "Aufträge",
},
assetHealth: {
title: "Anlagen unter Druck",
body_one: "{{count}} Anlage in diesem Bereich liegt im schlechten Zustandsbereich (offene Arbeit, Befunde oder veraltete Daten).",
body_other: "{{count}} Anlagen in diesem Bereich liegen im schlechten Zustandsbereich (offene Arbeit, Befunde oder veraltete Daten).",
action: "Anlagen",
},
allClear: {
title: "Betriebsüberblick",
body: "Keine dringenden Copilot-Signale in diesem Bereich für die letzten {{days}} Tage. Diagramme für Trends prüfen und Zuweisungen aktuell halten.",
},
},
copilotCards: {
  sync: {
    primary: "Nicht gesendete Änderungen ansehen",
    body_other: "{{count}} Änderungen sind auf diesem Gerät gespeichert und warten auf das Senden.",
    body_one: "1 Änderung ist auf diesem Gerät gespeichert und wartet auf das Senden.",
    title: "Noch nicht gesendete Änderungen",
  },
  requests: {
    primary: "Anfragen prüfen",
    body: "Öffnen Sie die Anfragen, um die Dringlichkeit zu sehen und Arbeit daraus zu machen.",
    title_other: "{{count}} dringende Anfragen prüfen",
    title_one: "1 dringende Anfrage prüfen",
  },
  brief: {
    draft: "Entwirf den Tagesplan für {{overdue}} überfällige und {{today}} heute fällige Punkte. Das Dringende zuerst, kurz und knapp.",
    primary: "Plan entwerfen",
    body: "{{overdue}} überfällig und {{today}} heute fällig. Der Assistent kann sie ordnen.",
    title: "Heutige Arbeit planen",
  },
},
syncBanner: {
pending_one: "Synchronisierung ausstehend: {{count}} Offline-Änderung wartet auf einen erneuten Versuch.",
pending_other: "Synchronisierung ausstehend: {{count}} Offline-Änderungen warten auf einen erneuten Versuch.",
},
healthEntries: {
ok: "OK",
syncLabel: "Synchronisierung",
syncPending_one: "{{count}} ausstehend",
syncPending_other: "{{count}} ausstehend",
syncUpToDate: "Aktuell",
failedSyncsLabel: "Fehlgeschlagene Synchronisierungen",
failedSyncsCount_one: "{{count}} fehlgeschlagen",
failedSyncsCount_other: "{{count}} fehlgeschlagen",
iotLabel: "IoT",
iotCount_one: "{{count}} Warnung",
iotCount_other: "{{count}} Warnungen",
iotTitle: "IoT-Warnungen",
iotEmpty: "Keine IoT-Warnungen.",
},
};
